import React from 'react';

// Styles & Assets
import styles from './ButtonQuestionPoll.module.css';

const ButtonQuestionPoll: React.FC<React.ButtonHTMLAttributes<HTMLButtonElement>> = ({ ...props }) => {

    return (
        <button
            {...props}
            className={`${styles.props} ${styles.buttonIcon}`}
        >
            {props.children}
        </button>
    );
};

export default ButtonQuestionPoll;